import React from 'react';

const Contact: React.FC = () =>  {

    return <h1>Contact Page</h1>;
};

export default Contact;